import { render, staticRenderFns } from "./FixedAmountDiscount.vue?vue&type=template&id=9877029c&"
import script from "./FixedAmountDiscount.vue?vue&type=script&lang=js&"
export * from "./FixedAmountDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports